var ExpandTrigger = /* @__PURE__ */ ((ExpandTrigger2) => {
  ExpandTrigger2["CLICK"] = "click";
  ExpandTrigger2["HOVER"] = "hover";
  return ExpandTrigger2;
})(ExpandTrigger || {});
const CASCADER_PANEL_INJECTION_KEY = Symbol();

export { CASCADER_PANEL_INJECTION_KEY, ExpandTrigger };
//# sourceMappingURL=types.mjs.map
